const EASE_OUT = 'cubic-bezier(0.2, 0.7, 0.2, 1)';

export const fadeInUpSX = (delayMs = 0) =>
  ({
    animation: `solutionsFadeInUp 0.32s ${EASE_OUT} ${delayMs}ms both`,
    '@keyframes solutionsFadeInUp': {
      from: { opacity: 0, transform: 'translateY(8px)' },
      to: { opacity: 1, transform: 'translateY(0)' },
    },
  }) as const;

export const fadeInSX = (delayMs = 0) =>
  ({
    animation: `solutionsFadeIn 0.22s ease-out ${delayMs}ms both`,
    '@keyframes solutionsFadeIn': {
      from: { opacity: 0 },
      to: { opacity: 1 },
    },
  }) as const;

export const slideInRightSX = {
  animation: `solutionsSlideInRight 0.26s ${EASE_OUT} both`,
  '@keyframes solutionsSlideInRight': {
    from: { opacity: 0, transform: 'translateX(16px)' },
    to: { opacity: 1, transform: 'translateX(0)' },
  },
} as const;

export const staggerChildrenSX = (childSelector: string, count = 12, stepMs = 25) => {
  const delays = Object.fromEntries(
    Array.from({ length: count }, (_, index) => [
      `& > ${childSelector}:nth-of-type(${index + 1})`,
      { animationDelay: `${index * stepMs}ms` },
    ]),
  );
  return {
    [`& > ${childSelector}`]: {
      animation: `solutionsStaggerIn 0.3s ${EASE_OUT} both`,
    },
    '@keyframes solutionsStaggerIn': {
      from: { opacity: 0, transform: 'translateY(6px)' },
      to: { opacity: 1, transform: 'translateY(0)' },
    },
    ...delays,
  };
};
